<template>
  <div class="fts-console-element-display">
    <div class="console-element-item" v-for="x in viewData" :key="x.id"> 
      <div class="console-element-content" :style="getStyle">
        <!-- information -->
        <template v-if="type === 'information'">
          <i class="console-element-icon" :class="informationIcon(x.type)" />
          <div class="console-element-name">{{x.displayName}}</div>
        </template>
        <!-- activity -->
        <template v-if="type === 'activity'">
          <fts-moji :emoji="x.emoji" :size="16" class="console-element-emoji" v-if="x.emoji" />
          <div class="console-element-name">{{x.name}}</div>
        </template>
        <!-- state -->
        <fts-state 
          :state="x"
          v-if="type === 'state'" />   
      </div>
      <!-- information fields -->
      <template v-if="type === 'information' && x.fields">
        <fts-console-element-display 
          :view-data="x.fields" 
          type="information"
          :deep="deep + 1" />
      </template>
    </div>
  </div>
</template>

<script>
import commons from '../../commons/commons';

import FTSState from "../../elements/FTSState";
import FTSMoji from "../../elements/FTSMoji";

export default {
  name: "fts-console-element-display",
  components: {
    "fts-state": FTSState,
    "fts-moji": FTSMoji,
  },
  props: {
    viewData: Array, 
    type: String,
    deep: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    informationIcon(type) {
      return commons.informationIcon(type);
    }
  },
  computed: {
    getStyle() {
      return this.deep && {
        "padding-left": `calc(${this.deep * 1}rem + 1.375rem)`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-console-element-display {
  .console-element-item {
    padding: .375rem 0;
    .console-element-content {
      display: flex;
      align-items: center;
      padding: 0.75rem 1.375rem;
      .console-element-emoji {
        margin-right: .575rem;
      }
      .console-element-icon {
        margin-right: .575rem;
        font-size: .875rem;
        color: $secondaryColor;
      }
      .console-element-name {
        @include text-overflow-ellipsis;
        font-size: .875rem;
      }
    }
  }
}
</style>